export interface LiveUpdate {
  time: string;
  tag: string;
  title: string;
  source: string;
  hot: boolean;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export const liveUpdates: LiveUpdate[] = [
  {
    time: '刚刚',
    tag: '团队声明',
    title: '林知夏工作室三点说明全文已更新，新增第三点关于取证进度的说明',
    source: '官方声明整理',
    hot: true,
  },
  {
    time: '6分钟前',
    tag: '第二弹',
    title: '周野追加致歉视频上线，品牌方撤下物料的清单同步更新',
    source: '当事人账号',
    hot: true,
  },
  {
    time: '18分钟前',
    tag: '反转',
    title: '阿鲤恋情时间线图更新到第四版，第三天凌晨的节点被标为关键反转',
    source: '网友整理',
    hot: false,
  },
  {
    time: '32分钟前',
    tag: '进行中',
    title: '蓝小满合约纠纷：前公司回应艺人方指控，称记录未做删改',
    source: '双方公告',
    hot: false,
  },
  {
    time: '51分钟前',
    tag: '已澄清',
    title: '沈砚新歌采样授权文件公开，音乐平台恢复歌曲推荐位',
    source: '制作人回应',
    hot: false,
  },
  {
    time: '1小时前',
    tag: '社交平台',
    title: '玖玖团队补充账号安全说明，列出异地登录时间点',
    source: '团队声明',
    hot: false,
  },
  {
    time: '2小时前',
    tag: '官方回应',
    title: '方屿剧组重申片场规范，未公开画面请勿二次传播',
    source: '剧组声明',
    hot: false,
  },
  {
    time: '4小时前',
    tag: '已澄清',
    title: '苏栖代言撞款风波的打样记录补齐，话题热度回落至榜单外',
    source: '品牌方公告',
    hot: false,
  },
];

export const faqs: FaqItem[] = [
  {
    q: '瓜田情报局的信息从哪里来？',
    a: '我们把公开可见的爆料帖、当事人账号发言、团队声明和权威媒体报道按时间顺序整理成条目，每一条都标注来源类别。本站不生产爆料，只做梳理与追踪，方便你快速看清一个瓜的来龙去脉。',
  },
  {
    q: '怎么判断一条瓜是真是假？',
    a: '我们建议三步走：先看信源是不是当事人或官方渠道，再看有没有可验证的时间线或原始画面，最后看是否存在前后矛盾。对尚未核实的条目，我们会在卡片上明确标注「信息仍在核实中」，请不要急着下结论。',
  },
  {
    q: '为什么有的瓜会突然反转？',
    a: '反转通常发生在两类节点：一是新的证据出现，比如完整时间片段或原始记录；二是当事人正式发声。我们会把反转节点单独标出来，并保留此前的记录，方便你对比前后差异，而不是直接删掉旧内容。',
  },
  {
    q: '「第二弹」是什么意思？',
    a: '当一个事件出现新一轮进展、新的当事人回应或新的爆料时，我们会把它标记为第二弹、第三弹，并追加到原有时间线的末尾，保证你既能看最新进展，也不会丢掉之前的脉络。',
  },
  {
    q: '多久更新一次？',
    a: '更新流在热点时段基本实时刷新，专题时间线一般在事件出现新节点后的半小时内补齐。你可以随时回到实时追踪板块查看最新条目，也可以把关注的专题收藏起来。',
  },
  {
    q: '可以投稿或者纠错吗？',
    a: '可以。页面底部的爆料投稿区支持提交线索和纠错说明，我们会核实后决定是否收录。请注意不要提交他人隐私信息或未经核实的指控，涉及个人隐私的内容我们不会展示。',
  },
];

export const testimonials: Testimonial[] = [
  {
    name: '柚子不加冰',
    role: '连续关注三个月的吃瓜群众',
    text: '以前看瓜要来回翻十几个账号，现在直接看时间线就够了。反转节点标得很清楚，不会再被半截截图带偏。',
  },
  {
    name: '深夜刷榜选手',
    role: '职场通勤党',
    text: '最喜欢实时追踪那一栏，通勤路上刷两分钟就知道昨晚又出了什么第二弹，不用再问朋友进度。',
  },
  {
    name: '理性吃瓜小组',
    role: '社区讨论组织者',
    text: '会把「待核实」和「已澄清」分开标注这点很加分，我们在群里讨论时会直接引用，省了很多争论。',
  },
  {
    name: '编辑部小林',
    role: '内容整理爱好者',
    text: '专题分类很细，团队声明和作品争议分开之后，找同类事件的效率高了不少，时间线页面尤其好用。',
  },
];

export const siteStats = [
  { label: '今日新增条目', value: '128' },
  { label: '追踪中专题', value: '36' },
  { label: '已标注反转事件', value: '12' },
  { label: '平均更新时间', value: '27分钟' },
];

export const tickerItems: string[] = [
  '实时更新：林知夏工作室三点说明已补全，第三点涉及取证进度',
  '反转提醒：阿鲤恋情时间线第三日凌晨节点被标为关键反转',
  '最新回应：周野追加致歉视频上线，合作品牌连夜撤下物料',
  '第二弹：蓝小满合约纠纷前公司放出沟通记录，双方各执一词',
  '已澄清：沈砚新歌采样授权文件公开，平台恢复推荐位',
  '追踪中：玖玖团队补充账号异地登录时间点，平台暂未回应',
];

export const navLinks = [
  { label: '实时追踪', href: '#live' },
  { label: '今日大瓜', href: '#trending' },
  { label: '专题分类', href: '#topics' },
  { label: '瓜情时间线', href: '#timeline' },
  { label: '常见问题', href: '#faq' },
  { label: '关于我们', href: '#about' },
];

export const contactChannels = [
  {
    icon: 'ri-mail-send-line',
    label: '线索投稿',
    value: 'tips@guatian-informant.cn',
    desc: '附上可核实的时间与来源，处理更快',
  },
  {
    icon: 'ri-edit-2-line',
    label: '内容纠错',
    value: 'fix@guatian-informant.cn',
    desc: '发现时间线或表述有误，欢迎指出',
  },
  {
    icon: 'ri-time-line',
    label: '更新时段',
    value: '每日 08:00 - 24:00',
    desc: '热点时段人工跟班，随时补条目',
  },
];